import { keyBy } from 'lodash';
import { combineReducers } from 'redux';
import { IinitialState } from '.';
import * as types from '../actions/actionTypes';
import { IsapJobMapping } from '../models';

export const selectSAPJobMappingsByID = (state: IinitialState) =>
    state.sapJobMappings.sapJobMappingsByID;

function sapJobMappingsByID(
    state: { [key: string]: IsapJobMapping } = {},
    action: any
): { [key: string]: IsapJobMapping } {
    switch (action.type) {
        case types.SET_SAP_JOB_MAPPING:
            return keyBy(action.data, 'id');
        default:
            return state;
    }
}

const sapJobMappingReducer = combineReducers({
    sapJobMappingsByID
});

export default sapJobMappingReducer;
